import { tooltipInit } from "./tooltip";
import { CURRENT_LANGUAGE_CODE } from "./language";
import initNewsCatalogFilters from "./newsCatalogFilters";

export default function articleFilter () {
    let LOCAL;

    if (CURRENT_LANGUAGE_CODE === "ru") {
        LOCAL = "ru";
    } else {
        LOCAL = "default";
    }
    function loadScript(src, callback) {
        const script = document.createElement("script");
        script.src = src;
        script.onload = callback;
        script.onerror = () => console.error(`Ошибка загрузки скрипта: ${src}`);
        document.head.appendChild(script);
    }

    if (document.querySelector('#datepicker')) loadScript("/static-backend/js/flatpickr.min.js", () => {

        loadScript("/static-backend/js/flatpickr.l10n.ru.js", () => {

            function initFlatpickr() {
                const container = document.querySelector('.article-list__filter-date');
                let closeIcon;
                if (container) {
                    closeIcon = container.querySelector('.js-article-list__clear-date');
                }

                const input = document.querySelector("#datepicker");
                if (!input) {
                    return;
                }

                flatpickr.l10ns.ru.rangeSeparator = ' - ';

                let previousDates = [];

                function repositionCalendar(instance) {
                    const calendar = instance.calendarContainer;
                    if (!calendar) return;

                    const parent = document.querySelector('.article-list__filter-date');
                    if (!parent) return;

                    const parentRect = parent.getBoundingClientRect();
                    const top = parentRect.bottom + 8;
                    const calendarWidth = calendar.offsetWidth;

                    let left = parentRect.left + (parentRect.width / 2) - (calendarWidth / 2);

                    if (window.innerWidth < 1024 && window.innerWidth > 500) {
                        left -= 5;
                    }

                    if (left < 0) {
                        left = 0;
                    }
                    if (left + calendarWidth > window.innerWidth) {
                        left = window.innerWidth - calendarWidth;
                    }

                    const scrollX = window.scrollX || window.pageXOffset;
                    const scrollY = window.scrollY || window.pageYOffset;

                    calendar.style.left = (left + scrollX) + "px";
                    calendar.style.top = (top + scrollY) + "px";
                }

                const fpInstance = flatpickr(input, {
                    mode: "range",
                    dateFormat: "d.m.Y",
                    defaultDate: input.value || [],
                    locale: LOCAL,
                    monthSelectorType: "static",
                    onOpen: function(selectedDates, dateStr, instance) {
                        previousDates = selectedDates.slice();
                        setTimeout(() => repositionCalendar(instance), 0);
                        container.classList.add('article-list__filter-date--active');
                    },
                    onClose: function(selectedDates, dateStr, instance) {
                        if (selectedDates.length === 1) {
                            instance.setDate(previousDates, false);
                        }
                        container.classList.remove('article-list__filter-date--active');
                        if (closeIcon) closeIcon.style.display = instance.input.value ? 'block' : 'none';
                        if (input.closest('[data-news-catalog-form]')) {
                            input.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    },
                    onChange: function(selectedDates, dateStr, instance) {
                        if (selectedDates.length > 1) {
                            if (closeIcon) closeIcon.style.display = 'block';
                    
                            // Добавляем запрос при выборе диапазона дат
                            const event = new Event('blur');
                            input.dispatchEvent(event);
                        } else {
                            if (closeIcon) closeIcon.style.display = 'none';
                        }
                    }
                });

                window.addEventListener('resize', () => {
                    if (fpInstance.isOpen) {
                        setTimeout(() => repositionCalendar(fpInstance), 50);
                    }
                });

                const observer = new MutationObserver(() => {
                    if (fpInstance.isOpen) {
                        repositionCalendar(fpInstance);
                    }
                });
                observer.observe(fpInstance.calendarContainer, {
                    attributes: true,
                    attributeFilter: ['style']
                });


                const yearInput = document.querySelector('.flatpickr-current-month input.cur-year');
                if (yearInput) {
                    yearInput.setAttribute('readonly', true);
                    yearInput.setAttribute('tabindex', '-1');
                }


                const datePlaceholders = {
                    ru: "Фильтр по дате",
                    en: "Filter by date",
                    es: "Filtrar por fecha",
                    pt: "Filtrar por data",
                    br: "Filtrar por data"
                };
                const datePlaceholder = datePlaceholders[CURRENT_LANGUAGE_CODE] || datePlaceholders.en;
                input.placeholder = datePlaceholder;

                container.addEventListener('click', (event) => {
                    if (event.target === closeIcon) {
                        fpInstance.clear();
                        input.placeholder = datePlaceholder;

                        fpInstance.close();
                        const eventName = input.closest('[data-news-catalog-form]') ? 'change' : 'blur';
                        input.dispatchEvent(new Event(eventName, { bubbles: true }));
                    } else {
                        fpInstance.open();
                    }
                });
            }

            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", initFlatpickr);
            } else {
                initFlatpickr();
            }
        });
    });

    document.addEventListener("DOMContentLoaded", function() {
        const newsForm = document.querySelector('[data-news-catalog-form]');
        if (newsForm) {
            initNewsCatalogFilters(newsForm);
            return;
        }
        let searchInput = document.querySelector('input[name="search"]');
        let dateInput = document.querySelector('input[name="date"]');
        const searchIcon = document.querySelector('.js-article-list__search');
        const searchIconSvg = document.querySelector('.js-article-list__search svg');
        const input = document.querySelector(".js-article-list__input-block input");
        const wrapper = document.querySelector(".js-article-list__input-block");
        let timeout = null;

        if (input && wrapper) {
            input.addEventListener("click", () => {
                wrapper.classList.add("article-list__input-block--focused");
            });

            input.addEventListener("blur", () => {
                wrapper.classList.remove("article-list__input-block--focused");
            });
        }

        function updateSearch() {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                sendSearchRequest();
            }, 2000);
        }

        function sendSearchRequest() {
            searchIconSvg.classList.add('article-list__search-icon');

            if (input && wrapper) {
                wrapper.classList.remove("article-list__input-block--focused");
            }

            // Инициализируем URLSearchParams с текущими параметрами URL для сохранения section
            let params = new URLSearchParams(window.location.search);

            // Обновляем или удаляем параметры фильтрации
            if (searchInput.value) {
                params.set("search", searchInput.value);
            } else {
                params.delete("search");
            }
            
            if (dateInput.value) {
                params.set("date", dateInput.value);
            } else {
                params.delete("date");
            }

            let selectedCategory = document.querySelector(".article-list__tag.article-list__selected");
            if (selectedCategory) {
                params.set("category", selectedCategory.dataset.categoryId);
            } else {
                params.delete("category");
            }

            // Удаляем параметр page при применении фильтров
            params.delete("page");

            let newUrl = "?" + params.toString();
            window.history.replaceState({}, "", newUrl);
            fetchResults(newUrl);

            if (params.toString() === "") {
                searchIconSvg.classList.remove("article-list__search-icon");
            }
        }

        function fetchResults(url) {
            fetch(url)  // Теперь fetch использует обновленный URL
                .then(response => response.text())
                .then(html => {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(html, "text/html");
                    const articleList = doc.querySelector(".js-article-list-container");
                    const documentArticleList = document.querySelector(".js-article-list-container");
                    documentArticleList.innerHTML = articleList.innerHTML;

                    const paginationContainer = document.querySelector(".pagination-nav");
                    const newPaginationContainer = doc.querySelector(".pagination-nav");
                    if (paginationContainer && newPaginationContainer) {
                        paginationContainer.innerHTML = newPaginationContainer.innerHTML;
                    } else if (!paginationContainer && newPaginationContainer) {
                        // Если пагинация появилась, добавляем её
                        document.querySelector(".article-list").appendChild(newPaginationContainer.cloneNode(true));
                    } else if (paginationContainer && !newPaginationContainer) {
                        // Если пагинация исчезла, удаляем её
                        paginationContainer.remove();
                    }
                    
                    // Повторно инициализируем tooltip для кнопок "поделиться"
                    tooltipInit();
                });
        }

        // Фильтрация категорий с использованием делегирования событий
        document.addEventListener("click", function(event) {
            // Проверяем, что клик был по элементу с классом article-list__tag
            if (event.target.classList.contains("article-list__tag")) {
                const tag = event.target;
                
                let isSelected = tag.classList.contains("article-list__selected");

                // Удаляем все фильтры
                const allTags = document.querySelectorAll(".article-list__tag");
                allTags.forEach(el => el.classList.remove("article-list__selected"));

                if (!isSelected) {
                    tag.classList.add("article-list__selected");
                }

                sendSearchRequest();
            }
        });

        if (searchInput) {
            searchInput.addEventListener("input", updateSearch);

            // Добавляем отправку запроса при нажатии Enter
            searchInput.addEventListener("keydown", function(event) {
                if (event.key === "Enter") {
                    event.preventDefault();
                    sendSearchRequest();
                }
            });
        }

        if (searchIcon) {
            searchIcon.addEventListener('click', function() {
                sendSearchRequest();
            });
        }

        if (dateInput) {
            dateInput.addEventListener("blur", sendSearchRequest);
        }
    });
}
